import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '~components/skeleton';
import LoaderCard from '../loader-card';
import './style.scss';
import '../style.scss';

function EventsLoader({ isMobile }) {
    return (
        <div className="events-loader">
            <div className="events-list">
                <h3>
                    <Skeleton
                        width={isMobile ? 135 : 180}
                        fontSize={isMobile ? 18 : 24}
                        lineHeight={isMobile ? 24 : 40}
                    />
                </h3>

                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />
                <LoaderCard isMobile={isMobile} />

                <button type="button" className="events-list__expand-btn">
                    <Skeleton
                        width={isMobile ? 92 : 95}
                        fontSize={isMobile ? 18 : 15}
                        lineHeight={20}
                    />
                </button>
            </div>
        </div>
    );
}

EventsLoader.propTypes = {
    isMobile: PropTypes.bool.isRequired,
}

export default EventsLoader;
export { EventsLoader };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/events-list/loader/index.js